import { render } from "./CompanyGrid.vue?vue&type=template&id=6d2a0a3e"
import script from "./CompanyGrid.vue?vue&type=script&lang=js"
export * from "./CompanyGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__